import { getChoicesNoticeDescription } from '../helpers/get-choices-notice-description'
import { Text } from '@components/gassan-ui/Typography/Text'
import { cn } from '@lib/cn'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'

type DefaultVariant = {
  title: string
  label: string
  variant: 'default'
}

type ChoicesVariant = {
  variant: 'choices'
  title?: never
  label?: never
}

type Props = DefaultVariant | ChoicesVariant

export const Notice: FC<Props> = ({ title, label, variant }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('other')
  const choicesDescription = getChoicesNoticeDescription(
    t('choices-product-notice-description'),
    language,
  )

  return (
    <div className={cn('mb-6 mt-6 p-4 lg:p-6', 'border border-shade-500')}>
      <Text variant="regular-bold" className="mb-1 text-shade-500">
        {variant === 'default' ? title : t('choices-product-notice-title')}
      </Text>
      <Text
        color="shade500"
        className="mb-0"
        dangerouslySetInnerHTML={{
          __html: variant === 'default' ? label : choicesDescription,
        }}
      ></Text>
    </div>
  )
}
